import { render } from "./SimpleBackButton.vue?vue&type=template&id=021afdb5&scoped=true"
import script from "./SimpleBackButton.vue?vue&type=script&lang=js"
export * from "./SimpleBackButton.vue?vue&type=script&lang=js"

import "./SimpleBackButton.vue?vue&type=style&index=0&id=021afdb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021afdb5"]])

export default __exports__